export const ACTIVATE_ATTIRE_CATEGORIES = ['Njk=', 'MTEx'];
